import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "selected"]

  static values = { types: Array, size: Number }

  connect() {
    var _this = this

    // The browser does not support the required APIs, we don't allow
    // drag and dropping files
    if (!window.File || !window.FileList || !window.FileReader) {
      return
    }

    // The browser won't allow us setting dynamically the value of the
    // input file, we can't allow drag and dropping files
    if (!App.browserIsChrome && !App.browserIsSafari) {
      return
    }

    var lastEnter

    $("body").on("dragover", function (e) {
      e.preventDefault()
      e.stopPropagation()

      lastEnter = e.target

      _this.enterUploadState()
    })

    $("body").on("dragleave", function (e) {
      e.preventDefault()
      e.stopPropagation()

      if (lastEnter === e.target) {
        _this.exitUploadState()
      }
    })

    $("body").on("drop", function (e) {
      e.preventDefault()
      e.stopPropagation()

      _this.dropFile(e)
    })
  }

  enterUploadState() {
    if ($("#upload-overlay").length == 0) {
      $("body").append("<div id='upload-overlay'><div class='upload-instructions'><i class='far fa-upload'></i><div>Drop to upload the file</div></div></div>")
    }

    $("#upload-overlay").height($(document).height()).css({
      "opacity": 1,
      "position": "absolute",
      "top": 0,
      "left": 0,
      "background-color": "rgba(255, 87, 34, 0.8)",
      "width": "100%",
      "z-index": 11000
    })
  }

  exitUploadState() {
    $("#upload-overlay").css({
      opacity: 0,
      "z-index": -1
    })
  }

  dropFile(e) {
    $("#upload-overlay").css({
      opacity: 0,
      "z-index": -1
    })

    this.fileInputTarget.files = e.originalEvent.dataTransfer.files

    // We manually trigger the "change" event as else it's not triggered
    // by the browser and we don't enter the "selectFile" function.
    this.fileInputTarget.dispatchEvent(new Event("change"))
  }

  openFileSelection() {
    $(this.fileInputTarget).trigger("click")
  }

  selectFile(e) {
    var acceptedExtensions = this.typesValue
    var maxSize = this.sizeValue
    var nameSplitted = e.target.files[0].name.split(".")

    if (acceptedExtensions.indexOf(nameSplitted[nameSplitted.length - 1]) == -1) {
      if (acceptedExtensions.length == 1) {
        var message = `You can only upload ${acceptedExtensions} files.`
      } else {
        var message = `You can only upload files with the following extensions: ${acceptedExtensions.join(", ")}.`
      }

      this.fileInputTarget.value = ""
      App.displayFlash("danger", message)
    } else if (e.target.files[0].size > maxSize) {
      var message = `The maximum size allowed for the file is ${(maxSize / 1000000).toFixed(0)} MB.`

      this.fileInputTarget.value = ""
      App.displayFlash("danger", message)
    } else {
      this.selectedTarget.innerHTML = `Selected: ${encodeURI(e.target.files[0].name)}`
      this.selectedTarget.parentElement.style.display = "block"
    }
  }

  closeSelected() {
    this.fileInputTarget.value = ""
    this.selectedTarget.parentElement.style.display = "none"
  }
 }
